import React from "react";
import
{
    Box,
    Card,
    CardContent,
    Divider,
    Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    cellContent: {
        width: '180px',
        flexBasis: '180px',
        padding: 8
    }
}));

const VipExperienceAccordianCard = (props) =>
{
    const classess = useStyles();
    const { classes, item } = props;
    const vipExperienceInfo = item.actualData;
    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: "none" }} >
                <CardContent className={classess.cardContent}>
                    <Box className={classes.rowContent}>
                        <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Contact Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{vipExperienceInfo.contactName}</span>
                                </Typography>
                            </Box>
                        </Box>

                        <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Contact Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>{vipExperienceInfo.contactEmail}</span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Contact No
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{vipExperienceInfo.contactCellNo}</span>
                                </Typography>

                            </Box>
                        </Box>
                        {/* <Box className={classess.cellContent}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    IsPhoto
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>{vipExperienceInfo.isPhoto == true ? 'Yes' : 'No'}</span>
                                </Typography>

                            </Box>
                        </Box> */}

                        {vipExperienceInfo.guest1 &&
                            <Box className={classess.cellContent}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Guest1
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{vipExperienceInfo.guest1}</span>
                                    </Typography>
                                </Box>
                            </Box>
                        }
                        {vipExperienceInfo.guest2 &&
                            <Box className={classess.cellContent}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Guest2
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{vipExperienceInfo.guest2}</span>
                                    </Typography>
                                </Box>
                            </Box>
                        }{vipExperienceInfo.guest3 &&
                            <Box className={classess.cellContent}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Guest3
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{vipExperienceInfo.guest3}</span>
                                    </Typography>
                                </Box>
                            </Box>
                        }{vipExperienceInfo.guest4 &&
                            <Box className={classess.cellContent}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Guest4
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{vipExperienceInfo.guest4}</span>
                                    </Typography>
                                </Box>
                            </Box>
                        }{vipExperienceInfo.guest5 &&
                            <Box className={classess.cellContent}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Guest5
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>{vipExperienceInfo.guest5}</span>
                                    </Typography>
                                </Box>
                            </Box>
                        }
                    </Box>
                </CardContent>
            </Card>
        </>
    )
}

export default VipExperienceAccordianCard;